const Graph = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 2H3C2.44772 2 2 2.44772 2 3V27C2 27.5523 2.44772 28 3 28H5C5.55228 28 6 27.5523 6 27V3C6 2.44772 5.55228 2 5 2Z"
        fill={color}
      />
      <path
        d="M11 9H9C8.44772 9 8 9.44772 8 10V27C8 27.5523 8.44772 28 9 28H11C11.5523 28 12 27.5523 12 27V10C12 9.44772 11.5523 9 11 9Z"
        fill={color}
      />
      <path
        d="M17 16H15C14.4477 16 14 16.4477 14 17V27C14 27.5523 14.4477 28 15 28H17C17.5523 28 18 27.5523 18 27V17C18 16.4477 17.5523 16 17 16Z"
        fill={color}
      />
      <path
        d="M23 9H21C20.4477 9 20 9.44772 20 10V27C20 27.5523 20.4477 28 21 28H23C23.5523 28 24 27.5523 24 27V10C24 9.44772 23.5523 9 23 9Z"
        fill={color}
      />
      <path
        d="M29 16H27C26.4477 16 26 16.4477 26 17V27C26 27.5523 26.4477 28 27 28H29C29.5523 28 30 27.5523 30 27V17C30 16.4477 29.5523 16 29 16Z"
        fill={color}
      />
    </svg>
  );
};
export default Graph;
